<template>
  <Layout>
    <template #header>
      <Heading class="vc-header">
        {{ $t('ppm_modal__vc_more_info_heading') }}
      </Heading>
    </template>

    <template #default>
      <div class="vc-main">
        <div class="vc-cannot-statements">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <Paragraph v-html="$t('ppm_modal__vc_more_info_text_p1')" />

          <!-- eslint-disable-next-line vue/no-v-html -->
          <Paragraph v-html="$t('ppm_modal__vc_more_info_text_p2')" />

          <!-- eslint-disable-next-line vue/no-v-html -->
          <Paragraph v-html="$t('ppm_modal__vc_more_info_text_p3')" />
        </div>

        <Paragraph>
          {{ $t('ppm_modal__vc_more_info_text_p4') }}
        </Paragraph>

        <a
          :href="$t('dashboard__support_link_url')"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Paragraph class="vc-link">{{ $t('global_learn_more') }}</Paragraph>
        </a>
      </div>
    </template>

    <template #footer>
      <HotPinkButton
        @click="
          $emit('go-to-add-payment-method-form', 'STRIPE_CARD_ISSUING_DIGITAL')
        "
      >
        {{ $t('ppm_modal__more_info_confirm_button') }}
      </HotPinkButton>
      <NavyButton @click="$emit('go-to-add-payment-method')">
        {{ $t('ppm_modal__more_info_cancel_button') }}
      </NavyButton>
    </template>
  </Layout>
</template>

<script>
import Layout from '../../layouts/Layout.vue'
import Heading from '../../typography/Heading3.vue'
import Paragraph from '../../typography/Paragraph.vue'
import HotPinkButton from '../../buttons/HotPinkButton.vue'
import NavyButton from '../../buttons/NavyButton.vue'

export default {
  components: {
    Layout,
    Heading,
    Paragraph,
    HotPinkButton,
    NavyButton,
  },
}
</script>

<style lang="postcss" scoped>
.vc-header {
  /* Base */
  @apply tw-max-w-[208px];

  /* Desktop */
  @apply lg:tw-max-w-none;
}

.vc-main {
  /* Base */
  @apply tw-flex tw-flex-col tw-self-center tw-items-center tw-gap-5 tw-mt-10 tw-mb-4;

  /* Desktop */
  @apply lg:tw-max-w-none;
}

.vc-main >>> p {
  @apply tw-w-full;
  text-align: left;
}

.vc-link {
  /* Base */
  @apply tw-text-[#325CF3];
}

.vc-cannot-statements {
  @apply tw-flex tw-justify-start tw-flex-col tw-gap-5;
}
</style>
